import { CategoryLabelModel } from '@src/models';
import { getLabelColor } from './label-color';

export const toCustomlabel = (label: CategoryLabelModel): CategoryLabelModel => {
  // do not touch supported label types
  if (label.type === 'LABEL_TYPE_CUSTOM' || label.type === 'LABEL_TYPE_SWAN') {
    return label;
  }
  const color = getLabelColor(label);

  if (label.type === 'LABEL_TYPE_SUSTAINABILITY') {
    return { ...label, type: 'LABEL_TYPE_CUSTOM', color };
  }

  return {
    ...label,
    type: 'LABEL_TYPE_CUSTOM',
    color: label.color,
    icon: label.icon,
  };
};
